module.exports = __webpack_public_path__ + "img/4-6-tour-2.c4bf5423.jpg";